import React from 'react';

const PauseIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg" width="490" height="490" viewBox="0 0 24 24">
    <path d="M5.966 0C6.818 0 7.52.673 7.59 1.528l.006.144v18.656c0 .874-.656 1.593-1.49 1.666L5.965 22H1.63C.78 22 .077 21.327.006 20.472L0 20.328V1.672C0 .798.657.079 1.49.006L1.632 0h4.335zm10.403 0c.852 0 1.554.673 1.625 1.528l.006.144v18.656c0 .874-.657 1.593-1.49 1.666l-.141.006h-4.335c-.852 0-1.554-.673-1.625-1.528l-.006-.144V1.672c0-.874.656-1.593 1.49-1.666L12.035 0h4.335zM5.966 1.567H1.63c-.042 0-.078.027-.094.064l-.008.04v18.657c0 .043.026.08.063.097l.04.008h4.334c.042 0 .078-.027.094-.064l.008-.04V1.671c0-.058-.046-.105-.102-.105zm10.403 0h-4.335c-.042 0-.079.027-.094.064l-.008.04v18.657c0 .043.026.08.062.097l.04.008h4.335c.042 0 .078-.027.094-.064l.008-.04V1.671c0-.058-.046-.105-.102-.105z" transform="translate(-1182 -812) translate(135 365) translate(20 377) translate(10 51) translate(1017 19) translate(3 1)"/>
  </svg>

);

export default PauseIcon;
